// extracted by mini-css-extract-plugin
export default {"bubble":"style--bubble--d4be4c"};